// In case we want to add more custom stuff here in future
export const trackGoogleEvent = (eventCategory, eventAction, eventLabel) => {
  if(window.ga) {
      ga('gtm1.send', 'event', eventCategory, eventAction, eventLabel);
  }
}


/** WEBPACK FOOTER **
 ** ./utils/googleEvents.js
 **/